import { FeatureFlags } from '../../../common/model/config';

export const refeicaoOnlineFeatureFlags: FeatureFlags = {
  hideBackButton: false,
};
